import { Button, Col, Layout, Modal, Row, Select, Table, Tooltip, Typography } from "antd";
import { useFiltrosAndTable } from "./useFiltrosAndTable";
import locale from 'antd/es/locale/pt_BR';
import { removeAcento } from "../../../../../../../utils/RemoveAcentos";
import { forwardRef } from "react";

// @ts-ignore
import ImagemLogo from './../../../../../../../assets/logo.png';
import { RedoOutlined } from "@ant-design/icons";

const { Text, Title } = Typography

interface IProps {
    activeKeyTabs: string
    clickNavigateTab: (aba: string) => void
    refFiltersGlobal: any
    setLoadingScreen: (val: boolean) => void
    loadingScreen: boolean
}

const FiltrosAndTable = forwardRef((
    {
        activeKeyTabs,
        clickNavigateTab,
        refFiltersGlobal,
        setLoadingScreen,
        loadingScreen
    }: IProps,
    ref?: React.ForwardedRef<any>
) => {

    const {
        onChangeSelectDataInicio,
        onChangeSelectDataFim,
        filterDataInicio,
        filterDataFim,
        onChangeSelectTipo,
        valueTipoId,
        dadosTabelaState,
        columns,
        refContagemDoFiltro,

        valueContratoId,
        dataListContrato,
        onChangeSelectContratos,

        valueCidadesDoContratoId,
        dataListCidadesDoContrato,
        onChangeSelectCidadesDoContratos,

        valueUsuariosDoContratoId,
        dataListUsuariosDoContrato,
        onChangeSelectUsuariosDoContratos,

        visibleModalModulosPorUsuario,
        handleCancelModalModulosPorUsuario,
        loadingTableModulos,
        columnsModalModulosPorUsuario,
        dadosTabelaModalModulosPorUsuario,
        onRefreshPage,

    } = useFiltrosAndTable({ refFiltersGlobal, activeKeyTabs, setLoadingScreen })

    return (
        <div
            ref={ref}
            style={{
                margin: 0,
                padding: 0
            }}
            className="layout_UltimoAcesso_cvrehjvfqw"
        >
            <Layout
                style={{
                    borderRadius: 8,
                }}
                className="layoutVGrey_UltimoAcesso_lvbweqrafw"
            >
                <Row>
                    <Layout
                        className="layout_UltimoAcesso_cvrehjvfqw"
                    >
                        <div
                            className="divImgGovFacilRel_UltimoAcesso_fewkhgfvqof"
                        >
                            <img
                                className="imgRelUltimoAcesso_fewhljbv"
                                style={{
                                    width: '200px'
                                }}
                                src={ImagemLogo}
                            />
                        </div>
                    </Layout>
                </Row>
                <Row>
                    <Col span={24}>
                        <Layout

                            className="layout_UltimoAcesso_cvrehjvfqw layoutStyledSelectandFilterUltimoAcesso_cwrejhfvbwaou"
                        >
                            <Row
                                style={{
                                    alignItems: 'center'
                                }}
                            >
                                <Col
                                    style={{
                                        margin: 5,
                                        marginLeft: 10,
                                        marginRight: 10
                                    }}
                                >
                                    <Title
                                        style={{
                                            margin: 0
                                            // marginTop: 0,
                                            // marginLeft: 0,
                                            // marginBottom: 0,
                                            // marginRight: 15,
                                        }}
                                        level={5}
                                        type="secondary"
                                    >
                                        {"Filtros: "}
                                    </Title>
                                </Col>
                                <Row>
                                    <Col
                                        className="colSelectRelUltimosAcessos_dewqhfvqoowef"
                                    >
                                        <div
                                            className='divColOpAnaliseFilters_chjbvchlebvqwrewvbosd'
                                        >
                                            <div
                                                className="titleSelectRelUltimosAcessos_cewlfhjcvbqweofbv"
                                            >
                                                <Text>{'Contrato:'}</Text>
                                            </div>
                                            <div
                                                className="selectRelUltimoAcess_vwqeralhvjbwaw"
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Selecione um contrato"
                                                    optionFilterProp="children"
                                                    onChange={onChangeSelectContratos}
                                                    value={valueContratoId}
                                                    style={{
                                                        width: '100%',
                                                        margin: 0,
                                                        marginBottom: 2,
                                                        marginRight: 5,
                                                    }}
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                >
                                                    {
                                                        dataListContrato.map((item) => {
                                                            return (
                                                                <Select.Option
                                                                    value={item.id}
                                                                    key={item.id}
                                                                >
                                                                    {
                                                                        item?.poder?.nome ?
                                                                            item.nome + ' - ' + item?.poder?.nome
                                                                            :
                                                                            item.nome
                                                                    }
                                                                </Select.Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </div>
                                        </div>
                                    </Col>
                                    {
                                        dataListCidadesDoContrato.length > 0 && (
                                            <Col
                                                className="colSelectRelUltimosAcessos_dewqhfvqoowef"
                                            >
                                                <div
                                                    className='divColOpAnaliseFilters_chjbvchlebvqwrewvbosd'
                                                >
                                                    <div
                                                        className="titleSelectRelUltimosAcessos_cewlfhjcvbqweofbv"
                                                    >
                                                        <Text >{'Cidades:'}</Text>
                                                    </div>
                                                    <div
                                                        className="selectRelUltimoAcess_vwqeralhvjbwaw"
                                                    >
                                                        <Select
                                                            showSearch
                                                            placeholder="Selecione uma cidade"
                                                            optionFilterProp="children"
                                                            onChange={onChangeSelectCidadesDoContratos}
                                                            value={valueCidadesDoContratoId}
                                                            allowClear
                                                            style={{
                                                                width: '100%',
                                                                margin: 0,
                                                                marginBottom: 2,
                                                                marginRight: 5,
                                                            }}
                                                            filterOption={(input: any, option: any) => {
                                                                let textDigit = removeAcento(input)
                                                                let listCidade = removeAcento(option?.children);
                                                                return listCidade.indexOf(textDigit) >= 0
                                                            }}
                                                        >
                                                            {
                                                                dataListCidadesDoContrato.map((item) => {
                                                                    return (
                                                                        <Select.Option
                                                                            value={item.id}
                                                                            key={item.id}
                                                                        >
                                                                            {
                                                                                item.nome + ' - ' + item.uf
                                                                            }
                                                                        </Select.Option>
                                                                    )
                                                                })
                                                            }
                                                        </Select>
                                                    </div>
                                                </div>
                                            </Col>
                                        )
                                    }
                                    {
                                        dataListUsuariosDoContrato.length > 0 && (
                                            <Col
                                                className="colSelectRelUltimosAcessos_dewqhfvqoowef divRemoverDoRelatorio_dewhfvqwuoweg"
                                            >
                                                <div
                                                    className='divColOpAnaliseFilters_chjbvchlebvqwrewvbosd'
                                                >
                                                    <div
                                                        className="titleSelectRelUltimosAcessos_cewlfhjcvbqweofbv"
                                                    >
                                                        <Text >{'Remover do relatório:'}</Text>
                                                    </div>
                                                    <div
                                                        className="selectRelUltimoAcess_vwqeralhvjbwaw"
                                                    >
                                                        <Select
                                                            showSearch
                                                            placeholder="Selecione um usuário"
                                                            optionFilterProp="children"
                                                            mode="multiple"
                                                            onChange={onChangeSelectUsuariosDoContratos}
                                                            value={valueUsuariosDoContratoId}
                                                            // allowClear
                                                            style={{
                                                                width: '100%',
                                                                margin: 0,
                                                                marginBottom: 2,
                                                                marginRight: 5,
                                                            }}
                                                            filterOption={(input: any, option: any) => {
                                                                let textDigit = removeAcento(input)
                                                                let listCidade = removeAcento(option?.children);
                                                                return listCidade.indexOf(textDigit) >= 0
                                                            }}
                                                        >
                                                            {
                                                                dataListUsuariosDoContrato.map((item) => {
                                                                    return (
                                                                        <Select.Option
                                                                            value={item.id}
                                                                            key={item.id}
                                                                        >
                                                                            {
                                                                                item?.cargo?.nome ?
                                                                                    item.nome + ' - ' + item.cargo.nome
                                                                                    :
                                                                                    item.nome
                                                                            }
                                                                        </Select.Option>
                                                                    )
                                                                })
                                                            }
                                                        </Select>
                                                    </div>
                                                </div>
                                            </Col>
                                        )
                                    }
                                    {/* <Col
                                        style={{
                                            display: 'flex',
                                            // alignItems: 'end',
                                            margin: 10
                                        }}
                                    >
                                        <div
                                            className='divColOpAnaliseFilters_chjbvchlebvqwrewvbosd'
                                        >
                                            <div>
                                                <Text >{'Data de início:'}</Text>
                                            </div>
                                            <div
                                                className="selectRelUltimoAcess_vwqeralhvjbwaw"
                                                >
                                                <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                    <DatePicker
                                                        value={filterDataInicio}
                                                        onChange={onChangeSelectDataInicio}
                                                        required={false}
                                                        style={{
                                                            width: '100%'
                                                        }}
                                                        okLabel="Ok"
                                                        // clearLabel="Limpar"
                                                        cancelLabel="Cancelar"
                                                        // clearable
                                                        format="dd/MM/yyyy"
                                                        className="datePickerCOlors"

                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col
                                        style={{
                                            display: 'flex',
                                            margin: 10
                                        }}
                                    >
                                        <div
                                            className='divColOpAnaliseFilters_chjbvchlebvqwrewvbosd'
                                        // style={{ margin: 2 }}
                                        >
                                            <div>
                                                <Text >{'Data de fim:'}</Text>
                                            </div>
                                            <div
                                                className="selectRelUltimoAcess_vwqeralhvjbwaw"
                                                >
                                                <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                    <DatePicker
                                                        value={filterDataFim}
                                                        onChange={onChangeSelectDataFim}
                                                        required={false}
                                                        style={{
                                                            width: '100%'
                                                        }}
                                                        okLabel="Ok"
                                                        // clearLabel="Limpar"
                                                        cancelLabel="Cancelar"
                                                        // clearable
                                                        format="dd/MM/yyyy"
                                                        className="datePickerCOlors"

                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </div>
                                    </Col> */}

                                </Row>
                            </Row>
                        </Layout>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Layout
                            style={{
                                borderRadius: 8,
                                margin: 5,
                                padding: 5
                            }}
                            className="layout_UltimoAcesso_cvrehjvfqw"
                        >
                            <Table
                                style={{
                                    // marginTop: 50
                                }}
                                className='tableRelUltimoAcesso_fwelhvfweoaufyv'
                                rowKey={(record) => record._id}
                                // loading={loadingScreen}
                                // onRow={(record, rowIndex) => {
                                //     return {
                                //         onClick: event => { onclickTable(record, rowIndex) }, // click row
                                //         onDoubleClick: event => { }, // double click row
                                //         onContextMenu: event => { }, // right button click row
                                //         onMouseEnter: event => { }, // mouse enter row
                                //         onMouseLeave: event => { }, // mouse leave row
                                //     };
                                // }}
                                // rowSelection={rowSelection}
                                columns={columns}
                                dataSource={dadosTabelaState}
                                scroll={{ x: 950 }}
                                onChange={
                                    (pagination, filters, sorter, extra) => {
                                        refContagemDoFiltro.current = extra.currentDataSource
                                    }
                                }
                                title={(registros) => {

                                    return (
                                        <div
                                            // style={{
                                            //     padding: 10,
                                            //     margin: -8,
                                            //     marginBottom: 0.5,
                                            //     display: 'flex',
                                            //     justifyContent: 'space-between'
                                            // }}
                                            className="divTable_UltimoAcesso_awywfgbowreag divTable_Count_top"
                                        >
                                            <Text className="textCountDivTable_ultimosAcessos">
                                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                                    dadosTabelaState.length :
                                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                            </Text>
                                            {
                                                valueContratoId ?
                                                    <div className="divRemoverDoRelatorio_dewhfvqwuoweg">
                                                        <Tooltip title="Atualizar página" color="blue">
                                                            <Button
                                                                type="primary"
                                                                style={{
                                                                    fontSize: 20
                                                                }}
                                                                onClick={onRefreshPage}
                                                                icon={<RedoOutlined style={{ fontSize: 20 }} />}
                                                            />
                                                        </Tooltip>
                                                    </div>
                                                    :
                                                    <></>
                                            }
                                        </div>
                                    )
                                }}
                                footer={(registros) => {
                                    return (
                                        <div
                                            className="divTable_Count_bottom"
                                        >
                                            <Text>
                                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                                    dadosTabelaState.length :
                                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                            </Text>
                                        </div>
                                    )
                                }}
                                size="small"
                                pagination={{
                                    locale: { items_per_page: '' },
                                    showSizeChanger: false,

                                    // defaultPageSize: 100,
                                    pageSize: (dadosTabelaState.length + 10),

                                    // position: ['topRight', 'bottomRight'],
                                    position: [],
                                    // pageSizeOptions: ['5', '10', '20', '50', '100', '200', '1000']
                                }}
                                locale={locale.Table}
                            />
                        </Layout>
                    </Col>
                </Row>
            </Layout>
            <Modal
                title="Módulos por usuário"
                visible={visibleModalModulosPorUsuario}
                className="modalRelModulosPorUsuarios"
                onOk={handleCancelModalModulosPorUsuario}
                onCancel={handleCancelModalModulosPorUsuario}
                footer={[
                    <Button key="back" disabled={loadingTableModulos} onClick={handleCancelModalModulosPorUsuario}>
                        Fechar
                    </Button>
                ]}
                destroyOnClose
            >
                <div
                    className='layoutVGrey_UltimoAcesso_lvbweqrafw'
                    style={{
                        borderRadius: 8,
                        padding: 5
                    }}
                >
                    <div
                        className='layout_UltimoAcesso_cvrehjvfqw'
                        style={{
                            borderRadius: 8,
                            padding: 5,
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Text
                            style={{
                                marginRight: 10
                            }}
                        >
                            {'Contrato: '}
                            <Text strong>{
                                dadosTabelaModalModulosPorUsuario.length > 0 && dadosTabelaModalModulosPorUsuario[0]?.contrato ?
                                    dadosTabelaModalModulosPorUsuario[0].contrato
                                    :
                                    ""
                            }</Text>
                        </Text>
                        <Text
                            style={{
                                marginRight: 10
                            }}
                        >
                            {'Usuário: '}
                            <Text strong>{
                                dadosTabelaModalModulosPorUsuario.length > 0 && dadosTabelaModalModulosPorUsuario[0]?.usuario ?
                                    dadosTabelaModalModulosPorUsuario[0].usuario + ' - ' + dadosTabelaModalModulosPorUsuario[0]?.cargo
                                    :
                                    ""
                            }</Text>
                        </Text>
                        <Text
                            style={{
                                marginRight: 10
                            }}
                        >
                            {'Versão do app: '}
                            <Text strong>{
                                dadosTabelaModalModulosPorUsuario.length > 0 && dadosTabelaModalModulosPorUsuario[0]?.versao ?
                                    dadosTabelaModalModulosPorUsuario[0].versao
                                    :
                                    ""
                            }</Text>
                        </Text>
                    </div>
                </div>
                <Table
                    rowKey={(record) => record.dataEHora}
                    loading={loadingTableModulos}
                    columns={columnsModalModulosPorUsuario}
                    dataSource={dadosTabelaModalModulosPorUsuario.length > 0 && dadosTabelaModalModulosPorUsuario[0].acessos_modulos ? dadosTabelaModalModulosPorUsuario[0].acessos_modulos : []}
                    scroll={{ y: 400, x: 550 }}
                    size="small"
                    title={(registros) => {
                        return (
                            <div
                                // style={{
                                //     padding: 10,
                                //     margin: -8,
                                //     marginBottom: 0.5
                                // }}
                                className="divTable_UltimoAcesso_awywfgbowreag divTable_Count_top"
                            >
                                <Text>
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registros.length} de ${dadosTabelaModalModulosPorUsuario.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                className="divTable_Count_bottom"
                            >
                                <Text>
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registros.length} de ${dadosTabelaModalModulosPorUsuario.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: true,
                        pageSize: dadosTabelaModalModulosPorUsuario.length > 0 && dadosTabelaModalModulosPorUsuario[0].acessos_modulos ?
                            (dadosTabelaModalModulosPorUsuario[0].acessos_modulos.length + 10) : (10),
                        position: [],
                        // pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    locale={locale.Table}
                />
            </Modal>
        </div>
    )
})

export default FiltrosAndTable;
